
export default {
    name: 'Discount',
    props: {
        amount: {
            type: [String, Number],
            default: 'medium'
        },

    },
    components: {

    },
    mounted() {
    }
}